'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /Users/alexandrer/development/react-skeletor/~/react/react.js
// module id = 146
// module chunks = 0